export default "__VITE_ASSET__BRV_JLg6__"